import { api } from '@/v2/plugins/axios';
import { t } from '@/locales/index';

const API_PATH = '/v1/customer/groups';

class GroupsEntity {
	id = undefined;

	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
	}

	static create = async (data) => {
		return api.post(API_PATH, data);
	};

	static fetch = async (params) => {
		const res = await api.get(`${API_PATH}`, {
			params: {
				...params,
				filters: {
					...params.filters,
					is_system: 0,
				},
			},
		});
		const data = res?.data?.result?.data;
		const totalRecords = res?.data?.result?.total;

		return {
			data: data.map((obj) => {
				return new GroupsEntity(obj);
			}),
			totalRecords,
		};
	};

	static fetchWithSystem = async (params) => {
		const res = await api.get(`${API_PATH}`, {
			params: {
				...params,
				filters: {
					...params.filters,
				},
			},
		});
		const data = res?.data?.result?.data;
		const totalRecords = res?.data?.result?.total;

		return {
			data: data.map((obj) => {
				return new GroupsEntity(obj);
			}),
			totalRecords,
		};
	};

	static fetchWithAllGroups = async (params) => {
		const res = await api.get(`${API_PATH}`, {
			params: {
				...params,
				filters: {
					...params.filters,
					is_system: 0,
				},
			},
		});
		const data = res?.data?.result?.data;
		if(params.page == 1) data.unshift({id: null, name: t('contacts.all-groups')});
		const totalRecords = res?.data?.result?.total + 1;

		return {
			data: data.map((obj) => {
				return new GroupsEntity(obj);
			}),
			totalRecords,
		};
	};

	static get = async (id) => {
		return api.get(`${API_PATH}/${id}`);
	};

	static update = async (id, data) => {
		return api.patch(`${API_PATH}/${id}`, data);
	};

	remove = async () => {
		return api.delete(`${API_PATH}/${this.id}`);
	};

	static unassignContacts = async (groupId, customerIds) => {
		return api.post(`${API_PATH}/${groupId}/unassign-contacts`, {
			customer_ids: customerIds,
		});
	};

	static assignContacts = async (data) => {
		return api.post(`${API_PATH}/actions/assign-contacts`, data);
	};
}

export default GroupsEntity;
